module.exports = __webpack_public_path__ + "img/user.580e6ab4.svg";